<template>
  <v-container
    fluid
    class="pa-0"
    :grid-list-md="$vuetify.breakpoint.xsOnly"
    :grid-list-xl="$vuetify.breakpoint.smAndUp"
    fill-height
  >
    <v-layout column>
      <v-flex class="px-2 overflow-auto column" :class="{'flex-item': $vuetify.breakpoint.xsOnly}">
        <v-fade-transition>
          <v-icon v-if="showArrow && !hideArrow" style="position: fixed; bottom: 10px; left: 50%; transform: translateX(-50%); z-index: 100;" large color="white">keyboard_arrow_down</v-icon>
        </v-fade-transition>
        <v-flex>
          <vue-markdown :source="configuration.configuration ? configuration.configuration.welcomeText[$i18n.locale] : ''" :postrender="postRenderFormat" :anchorAttributes="{target: '_blank'}"></vue-markdown>
        </v-flex>
        <v-flex class="flex-none" v-if="configuration.configuration && configuration.configuration.refundAvailable">
          <v-btn :block="$vuetify.breakpoint.xsOnly" color="secondary blue-grey--text text--darken-2" round large class="mt-5" @click="$router.push({ name: routeNames.REFUND })">{{$t('main.start')}}</v-btn>
        </v-flex>
        <v-flex class="flex-none" v-else>
          <tip icon="warning" class="mb-3" color="warning" :text="$t('main.refund_unavailable')"/>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import routeNames from '@/router/route-names'
import MarkdownFormat from '@/mixins/MarkdownFormat'
import VueMarkdown from 'vue-markdown'
import ResponsivityMixins from '@/mixins/Responsivity'
import { mapState } from 'vuex'

export default {
  name: routeNames.MAIN,
  components: {
    VueMarkdown,
    Tip: () => import('@/components/Tip.vue')
  },
  mixins: [
    MarkdownFormat,
    ResponsivityMixins
  ],
  data () {
    return {
      routeNames
    }
  },
  computed: {
    ...mapState(['configuration'])
  },
  created () {
    this.$store.dispatch('resetData')
    this.$store.commit('setStep', 1)
  }
}
</script>
